import { render, staticRenderFns } from "./TwiceCode.vue?vue&type=template&id=0ae95def&scoped=true&"
import script from "./TwiceCode.vue?vue&type=script&lang=js&"
export * from "./TwiceCode.vue?vue&type=script&lang=js&"
import style0 from "./TwiceCode.vue?vue&type=style&index=0&id=0ae95def&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae95def",
  null
  
)

export default component.exports